import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlayerService {
  mobileMenuUpdate: Subject<boolean> = new Subject<boolean>();
  moreMenuUpdate: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  isPlayerInactiveBanned(data: any) {
    const playerActive = data?.playerProfile
      ? Boolean(data?.playerProfile.playerActive)
      : false;
    if (playerActive) {
      const playerBanned = data?.playerStop?.length > 0 ? true : false;
      return { playerActive: true, playerBanned: playerBanned };
    } else {
      return { playerActive: false, playerBanned: false };
    }
  }

  refreshMenuActive() {
    this.mobileMenuUpdate.next(true);
  }

  refreshMoreMenuActive() {
    this.moreMenuUpdate.next(true);
  }

  isPlayerIdentityVerified(playerData: any): boolean {
    let identVerified = false;
    const identObj =
      playerData?.playerIdent && playerData.playerIdent.length > 0
        ? playerData.playerIdent.find(
            (identItem) => identItem?.identVerification
          )
        : '';
    identVerified = identObj && identObj?.identVerification ? true : false;
    return identVerified;
  }

  async checkIdentityVerificationStatus(
    isIdentVerificationRequired: boolean,
    playerInformationService: any
  ): Promise<boolean> {
    // If identity verification is not required, return true immediately
    if (!isIdentVerificationRequired) {
      return true;
    }

    // Identity verification is required, check player's verification status
    try {
      const playerInformation =
        await playerInformationService.getPlayerInformation();
      return this.isPlayerIdentityVerified(playerInformation);
    } catch (error) {
      // If there's an error getting player info, assume not verified
      return false;
    }
  }
}
